import { cva } from 'class-variance-authority';
export const scrollContainerStyles = cva([
    'relative',
    'w-full',
    'before:pointer-events-none before:w-200 before:opacity-0 before:transition-all before:bg-gradient-to-r before:from-primary before:absolute before:h-full before:left-0 after:top-0',
    'after:pointer-events-none after:w-[16px] after:opacity-0 after:transition-all after:bg-gradient-to-l after:from-primary after:absolute after:h-full after:right-0 after:top-0',
], {
    variants: {
        overflowing: {
            left: 'before:opacity-100',
            right: 'after:opacity-100',
            both: 'before:opacity-100 after:opacity-100',
        },
    },
});
